import dayjs, { type Dayjs } from 'dayjs';

export function formatCurrency(
  value: number | null | undefined,
  currency = 'EUR',
): string {
  if (value == null || Number.isNaN(value)) {
    return '—';
  }

  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency,
    maximumFractionDigits: value % 1 === 0 ? 0 : 2,
  }).format(value);
}

export function formatEuro(value: number | null | undefined): string {
  return formatCurrency(value, 'EUR');
}

export function formatDateLabel(
  value: string | Date | Dayjs | null | undefined,
): string {
  if (!value) {
    return '—';
  }

  return dayjs(value).format('DD MMM YYYY');
}
